/**
 * Backwards-compatible entry point for `component-cart-quantity-selector.js`.
 *
 * `CartQuantitySelectorComponent` (and its `<cart-quantity-selector-component>`
 * custom element) is now defined alongside `QuantitySelectorComponent` inside
 * `component-quantity-selector.js`, so both elements register together from a
 * single module.
 *
 * This file remains only so existing `<script src=".../component-cart-quantity-selector.js">`
 * references (e.g. in `snippets/cart-products.liquid`) keep working. It is a
 * side-effect-only import: it has no named binding, so it can never fail with
 * "does not provide an export named 'QuantitySelectorComponent'" — it simply
 * guarantees the module that defines the element has been loaded.
 */
import '@theme/component-quantity-selector';
